import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'koreksikehadiran'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const masterRegion = 'Master/Region/list/'

export const koreksiKehadiranList = 'Kepegawaian/koreksiKehadiran/list/'
export const koreksiKehadiranListPegawai = 'Kepegawaian/koreksiKehadiran/listPegawai/'
export const koreksiKehadiranInactive = 'Kepegawaian/koreksiKehadiran/inactive/'
export const koreksiKehadiranCreate = 'Kepegawaian/koreksiKehadiran/create/'
export const koreksiKehadiranCreateAdmin = 'Kepegawaian/koreksiKehadiran/createAdmin/'
export const koreksiKehadiranUpdate = 'Kepegawaian/koreksiKehadiran/update/'
export const koreksiKehadiranDetail = 'Kepegawaian/koreksiKehadiran/detail/'
export const koreksiKehadiranApproval = 'Kepegawaian/koreksiKehadiran/approval/'
export const koreksiKehadiranDinas = 'Kepegawaian/koreksiKehadiran/dinas/'

export const EmployeeDetail = 'Kepegawaian/koreksiKehadiran/employee/'
export const getMinDate = 'Kepegawaian/koreksiKehadiran/getMinDate/'
export const checkDate = 'Kepegawaian/koreksiKehadiran/checkDate/'
export const list_pegawai = 'Kepegawaian/koreksiKehadiran/daftar_pegawai_add/'
export const getCorrectionTypes = 'Kepegawaian/koreksiKehadiran/correctionTypes/'


//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}